/** Used as an action type when selecting a multi imager model */
export const SET_MULTI_IMAGER = 'SET_MULTI_IMAGER'

/** Used as an action type when adding a multi imager lens */
export const CREATE_MULTI_IMAGER_LENS = 'CREATE_MULTI_IMAGER_LENS'

/** Used as an action type when adding a multi imager lens */
export const ADD_MULTI_IMAGER_LENS = 'ADD_MULTI_IMAGER_LENS'

/** Used as an action type when setting multi imager lens IDs */
export const ADD_LENS_IDS = 'ADD_LENS_IDS'

/** Used as an action type when copying a multi imager */
export const COPY_MULTI_IMAGER = 'COPY_MULTI_IMAGER'

/** Used as an action type when duplicating a multi imager lens */
export const DUPLICATE_MULTI_IMAGER_LENS = 'DUPLICATE_MULTI_IMAGER_LENS'

/** Used as an action type when destroying a multi imager */
export const DESTROY_MULTI_IMAGER = 'DESTROY_MULTI_IMAGER'

/** Used as an action type when removing a multi imager */
export const REMOVE_MULTI_IMAGER = 'REMOVE_MULTI_IMAGER'

/** Used as an action type when clearing a multi imager's lenses */
export const CLEAR_MULTI_IMAGER_LENSES = 'CLEAR_MULTI_IMAGER_LENSES'

/** Used as an action type when updating a fixed lens */
export const UPDATE_FIXED_LENS = 'UPDATE_FIXED_LENS'

/** Used as an action type when updating all lenses */
export const UPDATE_ALL_LENSES = 'UPDATE_ALL_LENSES'



// WEBPACK FOOTER //
// ./src/actions/multiImagerActionTypes.js